// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Banner/Actions.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Banner, Button} from '@sail/ui';

export const Actions = () => (
  <Banner
    type="default"
    title="Check your bank details"
    description="Your bank account information must be verified before receiving payouts."
    actions={
      <Button onPress={() => console.log('hello world')}>
        Update bank account
      </Button>
    }
  />
);
